// @ts-strict-ignore
import { convertDistance, DistanceUnit } from '@backend/lib-l10n-logic';
import RCSlider from 'rc-slider';
import 'rc-slider/assets/index.css';
import { useEffect, useState } from 'react';
import { useTheme } from 'styled-components';

import { useBusinessUnitContext } from '~/contexts/BusinessUnitContext/BusinessUnitContext';
import { useSearchFormContext } from '~/contexts/SearchFormContext/SearchFormContext';

import { getSliderStyles, SliderContainer } from './DistanceSlider.style';

type SliderProps = {
  max: number;
  min: number;
  onCurrentDistanceChange?: (value: number) => void;
};

export const DistanceSlider = ({ max, min, onCurrentDistanceChange }: SliderProps) => {
  const theme = useTheme();
  const sliderStyles = getSliderStyles(theme);
  const { distanceUnit } = useBusinessUnitContext();

  const {
    form: {
      distance: { value, onChange },
    },
  } = useSearchFormContext();

  const [currentValue, setCurrentValue] = useState(value);

  useEffect(() => {
    setCurrentValue(value);
  }, [value]);

  useEffect(() => {
    if (onCurrentDistanceChange) {
      onCurrentDistanceChange(currentValue);
    }
  }, [currentValue, onCurrentDistanceChange]);

  const convertToKM = (newValue: number | number[]) =>
    convertDistance({ value: Array.isArray(newValue) ? newValue[0] : newValue, unit: distanceUnit }, DistanceUnit.KM)
      .value;

  return (
    <SliderContainer>
      <RCSlider
        step={1}
        min={min}
        max={max}
        value={convertDistance({ value: currentValue, unit: DistanceUnit.KM }, distanceUnit, { precision: 0 }).value}
        styles={{
          track: sliderStyles.track,
          handle: sliderStyles.handle,
          rail: sliderStyles.rail,
        }}
        onChangeComplete={newValue => onChange(convertToKM(newValue))}
        onChange={newValue => setCurrentValue(convertToKM(newValue))}
      />
    </SliderContainer>
  );
};
